module.exports = {"id":"dp5_1l3q1","text":"Autonomy in problem solving","instructions":"Developing your own troubleshooting skills reduces reliance on others.","multiselect":false,"category":"5.1","questionType":"PickOne","random":false,"options":[{"id":"dp5_1l3q1-a1","text":"True","score":3.7},{"id":"dp5_1l3q1-a2","text":"Not sure","score":1.3},{"id":"dp5_1l3q1-a3","text":"False","score":1.3}],"groupTitle":"Digital Profiler Knowledge Matrix"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat5.1/l3q1.json
// module id = 1286
// module chunks = 41